import UoJLogo from '../../asserts/UOJ_logo.png';
import SccLogo from '../../asserts/SCC_logo.png';
import SE_project from '../../asserts/SE_project.png';
import Satellite from '../../asserts/Satellite.jpg';
import Robotics from '../../asserts/Robodk.png';
import CSImage from '../../asserts/cs-image.png';
import AiImage from '../../asserts/ai_image.png';
import EPL from '../../asserts/EPL.png';
import Zebra from '../../asserts/zebra.jpeg';
import HeathInsight from '../../asserts/Health_insight.png'

export const Bio = {
  name: "Adun Arosh Upathilak",
  roles: [
    "Full Stack Developer",
    "Mobile app Developer",
    "UI/UX Designer",
    "Programmer",
  ],
  description:
    "I am a motivated and adaptable individual with a passion for continuous learning and excellence. Dedicated to delivering high-quality results, I thrive on embracing new challenges and opportunities for growth. With a positive attitude and a strong commitment to achieving meaningful contributions, I am ready to make an impact and accomplish exceptional goals.",
  github: "https://github.com/Arosh-Upathilak",
  resume:
    "https://drive.google.com/file/d/1jxE2UK1bMydIRSuurtEFFaaRgUPiMQAU/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/aroshupathilak/",
  insta: "",
  facebook: "https://www.facebook.com/arosh.upathilak",

};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "React Native",
        image:
          "https://firebasestorage.googleapis.com/v0/b/protofilo-fe6a9.appspot.com/o/Personaldetails%2Freactnative.svg?alt=media&token=05b5e81b-dd45-4b81-9c68-9149f288466c",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Tailwind CSS",
        image:
          "https://firebasestorage.googleapis.com/v0/b/protofilo-fe6a9.appspot.com/o/Personaldetails%2Ftailwind.png?alt=media&token=ec132da2-8a83-475f-b3e7-4c3092f6cebc",
      },
      {
        name: "Netlify",
        image:
          "https://firebasestorage.googleapis.com/v0/b/protofilo-fe6a9.appspot.com/o/Personaldetails%2FNetlify.webp?alt=media&token=957d57ad-2af7-4ebd-817c-3c9e5ce1065b",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
    
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "PHP",
        image:
          "https://firebasestorage.googleapis.com/v0/b/protofilo-fe6a9.appspot.com/o/Personaldetails%2Fphp-logo.svg?alt=media&token=9e54814b-ff08-49f8-838a-220b7ac54c3b",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
 
  {
    title: "Others",
    skills: [
      {
        name: "Java",
        image:
          "https://firebasestorage.googleapis.com/v0/b/protofilo-fe6a9.appspot.com/o/Personaldetails%2FJava_logo.svg?alt=media&token=914b9a33-4940-4d7f-8458-ed838050364b",
      },
      {
        name: "C Language",
        image:
          "https://firebasestorage.googleapis.com/v0/b/protofilo-fe6a9.appspot.com/o/Personaldetails%2Fc.png?alt=media&token=f9260e5f-d0f7-42ca-8d42-97669d9b83a0",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
     
      {
        name: "Jupyter",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Jupyter_logo.svg/1767px-Jupyter_logo.svg.png",
      },
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
     
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      
      {
        name: "IntelliJ IDEA",
        image:
          "https://firebasestorage.googleapis.com/v0/b/protofilo-fe6a9.appspot.com/o/Personaldetails%2FIntelliJ_IDEA.png?alt=media&token=151bb01d-c132-47ba-b20e-83c8b454ac6d",
      },
      {
        name: "Postman",
        image:
          "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
      },
   
      {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      },
      {
        name: "AWS",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/amazonwebservices/amazonwebservices-original-wordmark.svg",
      },
      {
        name: "Ardino IDE",
        image:
          "https://firebasestorage.googleapis.com/v0/b/protofilo-fe6a9.appspot.com/o/Personaldetails%2FArduino_Logo.png?alt=media&token=b4164e2e-0be6-47b1-89f0-8d662f47c6d2",
      },
      {
        name: "Docker",
        image:
          "https://img.icons8.com/?size=100&id=cdYUlRaag9G9&format=png&color=000000",
      },
      {
        name: "Matlab",
        image:
          "https://img.icons8.com/?size=100&id=r5Y16PcDkoWI&format=png&color=000000",
      },
    ],
  },
];


export const education = [
  {
    id: 0,
    img: UoJLogo,
    school: "University of Jaffna",
    date: " 2021 - 2025 ",
    grade: "3.62 GPA(current)",
    desc: "I am currently pursuing a Bachelor of Science in Engineering (BSc. Eng.) in Computer Engineering at the University of Jaffna, where I have completed six semesters with a CGPA of 3.62. Alongside my academic studies, I actively contribute to the University as the Web Master for the Computer Engineering Society (CES), where I am responsible for managing the society’s website and ensuring its smooth operation",
    degree: "BSc.Eng in Computer Engineering ",
  },
  {
    id: 1,
    img: SccLogo,
    school: "CH/ Senanayaka College,Madampe",
    date: "2017 - 2019",
    grade: "AAC",
    desc: "I completed my Class 12 education at Senanayaka Collage Madampe, specializing in the Physical Science stream for my Advanced Level (A/L) studies.",
    degree: "physical science stream",
    stream:"physical science",
  },
  {
    id: 2,
    img: SccLogo,
    school: "CH/ Senanayaka College,Madampe",
    date: "2010 - 2016",
    grade: "8A's",
    desc: "I finished my class 11 education at Senanayaka College, Madampe.",
    degree: "Odinary Level",
  },
];

export const experience = [
  {
    id: 0,
    img: Zebra,
    Company: "Zebra Technologies",
    date: " 2025 Feb - 2025 Aug ",
    technologies: "\nC++,\n Java,\n C#,\n Git",
    position: "Intern Software Engineer",
    desc: "Worked with internal tools such as 123Scan, CoreScanner, JPOS, and OPS, integrating them into enterprise workflows. Developed and maintained features using Java, C#, and C++, improving cross-platform compatibility and efficiency. Collaborated with cross-functional teams to implement new features, resolve technical issues, and enhance product reliability. Actively participated in code reviews, testing, and deployment processes while following Agile development practices.",
    degree: "BSc.Eng in Computer Engineering ",
  },
  
];


export const projects = [
   {
    id: 12,
    title: "Engineering Lerning platform",
    date: "Apr 2024",
    description:
      "Engineering Learning Platform (ELP) is a full-stack web application designed to enhance the learning experience of engineering students. It provides interactive modules, project-based resources, and real-time collaboration tools. The platform is built using the MERN stack (MongoDB, Express.js, React, Node.js) with a modern Tailwind CSS interface for a seamless user experience.",
    image:EPL,
    tags: [
      "React","Tailwind CSS","Node Js","Express Js","MongoDB"
    ],
    
    category: "Web App",

    github: "https://github.com/Arosh-Upathilak/ELP-UOJ",
    webapp: "",
  },
  {
    id: 13,
    title: "Health Insights Dashboard",
    date: "July 2025",
    description:
      "Health Insights Dashboard is a data-driven web application designed to analyze and visualize patient health metrics. Built with Flask and SQLAlchemy, it enables users to track key indicators such as BMI, blood pressure, and heart rate trends. The system provides interactive charts, predictive insights, and a clean interface for better healthcare data interpretation and decision-making.",
    image:HeathInsight,
      tags: [
      "python","Flask","SQLAlchemy",
    ],
    
    category: "Web App",

    github: "https://github.com/Arosh-Upathilak/Health-Insights.git",
    webapp: "",
  },
  {
    id: 2,
    title: "Sinhala Spell and Grammar Checker",
    date: "Nov 2024",
    description:
      " Developed a Sinhala Spelling and Grammar Checker to enhance writing accuracy, utilizing natural language processing techniques to detect and correct spelling and grammar errors for improved clarity and correctness in Sinhala text.",
    image:AiImage,
    tags: [
      "python","React"
    ],
    
    category: "AI",

    github: "https://github.com/Arosh-Upathilak/Sinhala-Spelling-corrector-and-Grammar-Checker.git",
    webapp: "",
  },
  {
    id: 11,
    title: "Exam Registration UOJ",
    date: "May 2024 - Dec 2024",
  
    description:
      "The Exam Registration System is specifically designed for the Engineering Faculty of the University of Jaffna, tailored to streamline and optimize the exam registration process. It features custom business logic that aligns with the faculty's academic needs.",
    image:SE_project,
    tags: [
      ".NET",
      "Blazor",
      "MySQL",
      "AWS",
      "Jira",
      "Figma",
    ],
    category: "Web App",
    github: "https://github.com/AthulyaWeerakoon/ExamRegistrationUoJ/blob/master/README.md",
    webapp: "https://hivesphere.software/home",
    member: [
      {
        name: "Arosh Upathilak",
        img: "https://avatars.githubusercontent.com/u/150613388?v=4",
        linkedin: "https://www.linkedin.com/in/arosh-upathilak-540124260",
        github: "https://github.com/Arosh-Upathilak",
        role: "Senior Sofware Engineer",
      },
      {
        name: "Athulya Weerakoon",
        img: "https://avatars.githubusercontent.com/u/55914834?v=4",
        linkedin: "https://www.linkedin.com/in/athulya-weerakoon/",
        github: "https://avatars.githubusercontent.com/u/55914834?v=4",
        role: "Project Manager",
      },
      {
        name: "Ramith Yushmantha",
        img: "https://avatars.githubusercontent.com/u/78314361?v=4",
        linkedin: "https://www.linkedin.com/in/ramith-samarasekara/",
        github: "https://github.com/yush291",
        role: "Sofware Engineer",
      },
      {
        name: "Sachintha Nimesh",
        img: "https://avatars.githubusercontent.com/u/124299595?v=4",
        linkedin: "https://www.linkedin.com/in/sachintha-dissanayaka-565135201/",
        github: "https://github.com/SachinthaNimesh",
        role: "Senior Sofware Engineer",
      },
      {
        name: "Chathuni Tharusha",
        img: "https://avatars.githubusercontent.com/u/124289630?v=4",
        linkedin: "https://www.linkedin.com/in/chathuni-subasinghe-a5a91b220/",
        github: "https://github.com/ChathuniTharusha",
        role: "Front-End desinger",
      },
      {
        name: "Sachithra Oshadha",
        img: "https://avatars.githubusercontent.com/u/141540024?v=4",
        linkedin: "",
        github: "https://github.com/Sachithra-oshadha",
        role: "Business Analyst",
      },
      {
        name: "Tharusha Sathinthana",
        img: "https://avatars.githubusercontent.com/u/131230058?v=4",
        linkedin: "https://www.linkedin.com/in/tharusha-sachinthana-150773264/",
        github: "https://github.com/TharushaSachinthana",
        role: "Quality Assurance",
      },
    ],
  },
  {
    id: 9,
    title: "IEEE Computer Society University of Jaffna WEB Site",
    date: "Jan 2024 - Mar 2024",
    description:
      "The IEEE Computer Society - University of Jaffna Website is a comprehensive platform that keeps updated on the society’s activities and events. It provides easy access to upcoming programs, resources, and opportunities for networking, learning, and collaboration, making it the go-to hub for tech enthusiasts and professionals at the university.",
    image:CSImage,
    tags: [
      "React",
      "Spring Boot",
      "Mongodb",
      "Jira",
      "Figma",
    ],
    category: "Web App",
    github: "https://github.com/Arosh-Upathilak/CS_website-Samples-main/blob/main/README.md",
    webapp: "https://cs-website-uoj.netlify.app",
    member: [
      {
        name: "Arosh Upathilak",
        img: "https://avatars.githubusercontent.com/u/150613388?v=4",
        linkedin: "https://www.linkedin.com/in/arosh-upathilak-540124260",
        github: "https://github.com/Arosh-Upathilak",
        role: "Project Manager",
      },
      {
        name: "Ruwan Predeep",
        img: "https://avatars.githubusercontent.com/u/140706867?v=4",
        linkedin: "https://www.linkedin.com/in/ruwan-pradeep/",
        github: "https://github.com/RuwanPradeep0",
        role: "Backend Develper",
      },
      {
        name: "Salinda Hulangamuwa",
        img: "https://avatars.githubusercontent.com/u/150468057?v=4",
        linkedin: "https://www.linkedin.com/in/salinda-hulangamuwa-73a10a283/",
        github: "https://github.com/SalindaHulangamuwa",
        role: "Front-end Developer",
      },
      {
        name: "Parami Wijesinghe",
        img: "https://avatars.githubusercontent.com/u/146418513?v=4",
        linkedin: "https://www.linkedin.com/in/parami-wijesinghe-1ba023228/",
        github: "https://github.com/paramiwijesinghe",
        role: "Quality Assurance",
      },
    ],
  },
  {
    id: 0,
    title: "Satellite Dish Alignment System",
    date: "Apr 2024 ",
    description:
      "The Satellite Dish Alignment System is an embedded project designed to enhance the precision and efficiency of satellite dish positioning. This system comprises a Master Unit and a Slave Unit, working collaboratively to ensure optimal alignment with communication satellites.",
    image:Satellite,
    tags: [" C language", "Arduino IDE"],
    category: "Embedded",
    github: "https://github.com/Arosh-Upathilak/Satellite-Dish-Alignment-System-Embedded-Project/blob/main/README.md",
    webapp: "",

  },
  {
    id: 1,
    title: "Robotic ARM Manipulator assigned to do Pick Place task",
    date: "Apr 2024",
    description:
      "This project automates the Pick & Place task as part of a manufacturing process using a robotic arm (manipulator). The robotic system is simulated using RoboDK and analyzed with MATLAB (Robotics Toolbox) to verify trajectory planning and generate velocity profiles.",
    image:Robotics,
    tags: [
      "Robodk",
    ],
    
    category: "Robotic",

    github: "https://github.com/Arosh-Upathilak/Robotic-ARM-Manipulator-assigned-to-do-Pick-Place-task/blob/main/README.md",
    webapp: "",
  },
  {
    id: 2,
    title: "Sinhala Spell and Grammar Checker",
    date: "Nov 2024",
    description:
      " Developed a Sinhala Spelling and Grammar Checker to enhance writing accuracy, utilizing natural language processing techniques to detect and correct spelling and grammar errors for improved clarity and correctness in Sinhala text.",
    image:AiImage,
    tags: [
      "python","React"
    ],
    
    category: "AI",

    github: "https://github.com/Arosh-Upathilak/Sinhala-Spelling-corrector-and-Grammar-Checker.git",
    webapp: "",
  },
  
];

